import React, { useEffect, useState } from 'react'
import { Global } from '@emotion/react'
import { avaliableGeoInfoFilter } from '@ow/utils'
import { isArray } from 'lodash-es'
import useMap from './use-map'
import { styles } from './styles'

const transformJeoJson = (value) => {
  if (!isArray(value)) {
    return null
  }
  const features = avaliableGeoInfoFilter(value).map((v) => {
    const obj = { type: 'Feature' }
    obj.geometry = v
    return { geometry: v, type: 'Feature' }
  })
  return { features, type: 'FeatureCollection' }
}

const Gis = ({ defs = {}, origin }) => {
  const { slug } = defs
  const [containerSlug] = useState(
    `${slug}-container-${Math.round(Math.random() * 100)}`
  )

  const { init, amap, showJeojson } = useMap(containerSlug)

  useEffect(() => {
    init('normal')
  }, [])

  useEffect(() => {
    if (amap) {
      amap.clearMap()
      if (origin) {
        showJeojson(transformJeoJson(origin))
        amap.setFitView()
      }
    }
  }, [amap, origin])

  return (
    <>
      <Global styles={styles} />
      {/* {JSON.stringify(origin)} */}
      <div
        style={{
          width: 'calc(100% - 1.75rem)',
          height: '25rem',
          borderRadius: '0.1rem',
        }}
        id={containerSlug}
      />
    </>
  )
}

const Render = function ({ value }) {
  return <Gis {...value} />
}

export default Render

// import React, { useEffect, useState } from 'react'
// import { useAmap, useGeojson } from '@ow/maps/lib'
// // import { get } from 'lodash-es'
// const KEY = '96f3ce46e17dc6b30fa5434d32d4b1c8'
// const WIDTH = '400px'
// const HEIGHT = '600px'

// const transformJeoJson = (value) => {
//   const features = (value || []).map((v) => {
//     const obj = { type: 'Feature' }
//     obj.geometry = v
//     return { geometry: v, type: 'Feature' }
//   })
//   return { features, type: 'FeatureCollection' }
// }

// const Gis = function ({ origin, value }) {
//   console.log(origin, '111')
//   const { defs } = value
//   const [isLoading, setIsLoading] = useState(false)
//   const { init, setCenter, setZoom } = useAmap(defs.slug, KEY, {
//     plugins: [useGeojson],
//   })

//   useEffect(() => {
//     init(defs.slug)
//       .then((funcs) => {
//         const { addGeojson } = funcs
//         console.log(transformJeoJson(origin), 'dayin')
//         // if (origin[0].type === 'Point') {
//         //   setCenter(defs.slug, origin[0].type.coordinates)
//         // }
//         addGeojson(defs.slug, transformJeoJson(origin))
//         // if (rowData.dgeom && rowData.mgeom) {
//         //   const point = get(rowData, [
//         //     'dgeom',
//         //     'features',
//         //     '0',
//         //     'geometry',
//         //     'coordinates',
//         //   ])
//         //   funcs.addGeojsonWithMarker(defs.slug, rowData.dgeom, rowData.mgeom)
//         //   setCenter(defs.slug, point)
//         // }
//         setZoom(defs.slug, 18)
//         // const
//       })
//       .catch((e) => {
//         console.log(e)
//         if (e === undefined) {
//           setIsLoading(!isLoading)
//         }
//       })
//   }, [isLoading])

//   return (
//     <div
//       id={defs.slug}
//       style={{
//         width: WIDTH,
//         height: HEIGHT,
//       }}
//     />
//   )
// }
// export default Gis
